document.documentElement.classList.remove('no-js');

document.querySelectorAll('[data-product-card-link]').forEach((card) => {
  card.setAttribute('tabindex', '0');
  card.setAttribute('role', 'link');
  const openCard = (event) => {
    if (event.target.closest('a, button, select, input')) return;
    window.location.href = card.dataset.productCardLink;
  };
  card.addEventListener('click', openCard);
  card.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      window.location.href = card.dataset.productCardLink;
    }
  });
});

const menuButton = document.querySelector('.mobile-menu-button');
const navigation = document.querySelector('.primary-nav');
if (menuButton && navigation) {
  const menuLabel = menuButton.querySelector('.visually-hidden');
  const setMenuState = (open) => {
    menuButton.setAttribute('aria-expanded', String(open));
    navigation.classList.toggle('is-open', open);
    document.body.classList.toggle('menu-open', open);
    if (menuLabel) menuLabel.textContent = open ? 'Close menu' : 'Open menu';
  };
  menuButton.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    setMenuState(!open);
  });
  navigation.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenuState(false)));
  window.addEventListener('resize', () => { if (window.innerWidth > 900) setMenuState(false); });
}

let basketController = null;
const basketRoot = document.querySelector('[data-basket-root]');
if (basketRoot) {
  const storageKey = 'trifecta-basket-v1';
  const itemsContainer = basketRoot.querySelector('[data-basket-items]');
  const emptyState = basketRoot.querySelector('[data-basket-empty]');
  const summary = basketRoot.querySelector('[data-basket-summary]');
  const totalElement = basketRoot.querySelector('[data-basket-total]');
  const repeatTenRequest = basketRoot.querySelector('[data-repeat-ten-request]');
  const repeatTenEstimate = basketRoot.querySelector('[data-repeat-ten-estimate]');
  const repeatTenSavingElement = basketRoot.querySelector('[data-repeat-ten-saving]');
  const repeatTenTotalElement = basketRoot.querySelector('[data-repeat-ten-total]');
  const whatsappButton = basketRoot.querySelector('[data-basket-whatsapp]');
  const drawer = basketRoot.querySelector('.basket-drawer');
  const openButtons = Array.from(document.querySelectorAll('[data-basket-open]'));
  const closeButtons = Array.from(basketRoot.querySelectorAll('[data-basket-close]'));
  const countElements = Array.from(document.querySelectorAll('[data-basket-count]'));
  const currency = basketRoot.dataset.shopCurrency || 'EUR';
  const whatsappNumber = basketRoot.dataset.whatsappNumber || '';
  let items = [];

  try {
    const savedItems = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
    if (Array.isArray(savedItems)) {
      items = savedItems.filter((item) => item && item.variantId && Number(item.quantity) > 0);
    }
  } catch (error) {
    items = [];
  }

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
  }[character]));
  const formatMoney = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return `€${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  };
  const save = () => {
    try { window.localStorage.setItem(storageKey, JSON.stringify(items)); } catch (error) { /* Storage can be unavailable in private browsing. */ }
  };
  const buildWhatsAppMessage = (total, repeatTenRequested, repeatTenSaving) => {
    const lines = items.map((item, index) => {
      const subtotal = Number(item.price || 0) * Number(item.quantity || 1);
      return `${index + 1}. ${item.productTitle} — ${item.variantTitle}\nQuantity: ${item.quantity}\nUnit price: ${formatMoney(item.price)}\nSubtotal: ${formatMoney(subtotal)}`;
    });
    const loyaltyRequest = repeatTenRequested
      ? `\n\nTrifecta Repeat 10 eligibility check: REQUESTED\nPotential 10% saving if confirmed: -${formatMoney(repeatTenSaving)}\nPotential total if confirmed: ${formatMoney(total - repeatTenSaving)}\nPlease verify this using my completed order history for this WhatsApp number.`
      : '';
    return `Hello Trifecta Pharma, I would like to place the following order request:\n\n${lines.join('\n\n')}\n\nEstimated total: ${formatMoney(total)}${loyaltyRequest}\n\nPlease confirm availability, final pricing and the order details.`;
  };
  const renderBasket = () => {
    const count = items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    const total = items.reduce((sum, item) => sum + (Number(item.price || 0) * Number(item.quantity || 0)), 0);
    if (!items.length && repeatTenRequest) repeatTenRequest.checked = false;
    const repeatTenRequested = Boolean(repeatTenRequest?.checked);
    const repeatTenSaving = Math.round(total * 0.10);
    countElements.forEach((element) => { element.textContent = String(count); });
    if (emptyState) emptyState.hidden = items.length > 0;
    if (summary) summary.hidden = items.length === 0;
    if (totalElement) totalElement.textContent = formatMoney(total);
    if (repeatTenEstimate) repeatTenEstimate.hidden = !repeatTenRequested;
    if (repeatTenSavingElement) repeatTenSavingElement.textContent = `-${formatMoney(repeatTenSaving)}`;
    if (repeatTenTotalElement) repeatTenTotalElement.textContent = formatMoney(total - repeatTenSaving);

    if (itemsContainer) {
      itemsContainer.innerHTML = items.map((item) => `
        <article class="basket-item" data-basket-item="${escapeHtml(item.variantId)}">
          <div class="basket-item__details">
            <h3>${escapeHtml(item.productTitle)}</h3>
            <p>${escapeHtml(item.variantTitle)}</p>
            <strong>${formatMoney(item.price)}</strong>
          </div>
          <div class="basket-item__actions">
            <div class="basket-quantity" aria-label="Quantity for ${escapeHtml(item.productTitle)}">
              <button type="button" data-basket-action="decrease" aria-label="Decrease quantity">&minus;</button>
              <span>${Number(item.quantity)}</span>
              <button type="button" data-basket-action="increase" aria-label="Increase quantity">+</button>
            </div>
            <button class="basket-remove" type="button" data-basket-action="remove">Remove</button>
          </div>
        </article>
      `).join('');
    }

    if (whatsappButton) {
      if (items.length > 0 && whatsappNumber) {
        whatsappButton.href = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(buildWhatsAppMessage(total, repeatTenRequested, repeatTenSaving))}`;
        whatsappButton.removeAttribute('aria-disabled');
      } else {
        whatsappButton.href = '#';
        whatsappButton.setAttribute('aria-disabled', 'true');
      }
    }
  };
  const openBasket = () => {
    basketRoot.hidden = false;
    window.requestAnimationFrame(() => basketRoot.classList.add('is-open'));
    document.body.classList.add('basket-open');
    navigation?.classList.remove('is-open');
    menuButton?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
    const menuLabel = menuButton?.querySelector('.visually-hidden');
    if (menuLabel) menuLabel.textContent = 'Open menu';
    drawer?.querySelector('[data-basket-close]')?.focus();
  };
  const closeBasket = () => {
    basketRoot.classList.remove('is-open');
    document.body.classList.remove('basket-open');
    window.setTimeout(() => { if (!basketRoot.classList.contains('is-open')) basketRoot.hidden = true; }, 220);
  };

  basketController = {
    add(item) {
      if (!item?.variantId) return;
      const existing = items.find((basketItem) => String(basketItem.variantId) === String(item.variantId));
      if (existing) existing.quantity += 1;
      else items.push({ ...item, variantId: String(item.variantId), quantity: 1 });
      save();
      renderBasket();
      openBasket();
    }
  };

  openButtons.forEach((button) => button.addEventListener('click', openBasket));
  closeButtons.forEach((button) => button.addEventListener('click', closeBasket));
  basketRoot.addEventListener('click', (event) => { if (event.target === basketRoot) closeBasket(); });
  itemsContainer?.addEventListener('click', (event) => {
    const actionButton = event.target.closest('[data-basket-action]');
    const itemElement = actionButton?.closest('[data-basket-item]');
    if (!actionButton || !itemElement) return;
    const index = items.findIndex((item) => String(item.variantId) === itemElement.dataset.basketItem);
    if (index < 0) return;
    const action = actionButton.dataset.basketAction;
    if (action === 'increase') items[index].quantity += 1;
    if (action === 'decrease') items[index].quantity = Math.max(1, items[index].quantity - 1);
    if (action === 'remove') items.splice(index, 1);
    save();
    renderBasket();
  });
  whatsappButton?.addEventListener('click', (event) => {
    if (!items.length || !whatsappNumber) event.preventDefault();
  });
  repeatTenRequest?.addEventListener('change', renderBasket);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !basketRoot.hidden) closeBasket(); });
  renderBasket();
}

const catalogue = document.querySelector('[data-catalogue]');
if (catalogue) {
  const input = catalogue.querySelector('[data-catalogue-search]');
  const sort = catalogue.querySelector('[data-catalogue-sort]');
  const grid = catalogue.querySelector('[data-catalogue-grid]');
  const empty = catalogue.querySelector('[data-catalogue-empty]');
  const items = Array.from(grid.children);
  items.forEach((item, index) => { item.dataset.originalIndex = String(index); });
  const update = () => {
    const query = (input?.value || '').trim().toLowerCase();
    let visible = 0;
    items.forEach((item) => {
      const title = (item.dataset.title || item.textContent).toLowerCase();
      const match = title.includes(query);
      item.hidden = !match;
      if (match) visible += 1;
    });
    if (sort) {
      const direction = sort.value;
      const sorted = [...items].sort((a, b) => {
        if (direction === 'az') return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        if (direction === 'za') return (b.dataset.title || '').localeCompare(a.dataset.title || '');
        if (direction === 'low' || direction === 'high') {
          const aPrice = Number(a.dataset.price || 0);
          const bPrice = Number(b.dataset.price || 0);
          const aOut = aPrice >= 999999999;
          const bOut = bPrice >= 999999999;
          if (aOut !== bOut) return aOut ? 1 : -1;
          return direction === 'low' ? aPrice - bPrice : bPrice - aPrice;
        }
        return Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex);
      });
      sorted.forEach((item) => grid.appendChild(item));
    }
    if (empty) empty.hidden = visible !== 0;
  };
  input?.addEventListener('input', update);
  sort?.addEventListener('change', update);
}

const productDetail = document.querySelector('[data-product-detail]');
if (productDetail) {
  const variantData = productDetail.querySelector('[data-product-variants]');
  const selectors = Array.from(productDetail.querySelectorAll('[data-variant-option]'));
  const price = productDetail.querySelector('[data-variant-price]');
  const availability = productDetail.querySelector('[data-variant-availability]');
  const detailsAvailability = productDetail.querySelector('[data-details-availability]');
  const selectedOptions = productDetail.querySelector('[data-selected-options]');
  const addToBasket = productDetail.querySelector('[data-add-to-basket]');
  let variants = [];
  try { variants = JSON.parse(variantData?.textContent || '[]'); } catch (error) { variants = []; }
  if ((productDetail.dataset.productTitle || '').trim().toUpperCase() === 'HGH') {
    variants = variants.filter((variant) => !(variant.options[0] === '10 IU' && variant.options[1] === 'Single vial'));
  }
  let currentVariant = null;

  const optionValues = selectors.map((selector) => Array.from(selector.options, (option) => option.value));
  const refreshDependentOptions = () => {
    selectors.forEach((selector, index) => {
      if (index === 0) return;

      const validValues = new Set(
        variants
          .filter((variant) => selectors.slice(0, index).every((previousSelector, previousIndex) => (
            variant.options[previousIndex] === previousSelector.value
          )))
          .map((variant) => variant.options[index])
      );
      const currentValue = selector.value;
      selector.replaceChildren();
      optionValues[index].forEach((value) => {
        if (!validValues.has(value)) return;
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        selector.appendChild(option);
      });
      if (validValues.has(currentValue)) selector.value = currentValue;
    });
  };

  const updateVariant = () => {
    refreshDependentOptions();
    const choices = selectors.map((selector) => selector.value);
const variant = selectors.length === 0
  ? variants[0]
  : variants.find((item) =>
      item.options.every((option, index) => option === choices[index])
    );

if (!variant) return;
currentVariant = variant;

    const inStock = Boolean(variant.available);
    const displayVariantTitle = variant.title === 'Default Title' ? 'Vial' : variant.title;
    if (price) price.textContent = inStock && variant.price > 0 ? variant.priceFormatted : 'Currently out of stock';
    if (availability) {
      availability.classList.toggle('availability--out', !inStock);
      availability.innerHTML = `<span></span>${inStock ? ' In stock' : ' Currently out of stock'}`;
    }
    if (detailsAvailability) detailsAvailability.textContent = inStock ? 'In stock' : 'Out of stock';
    if (selectedOptions) selectedOptions.textContent = displayVariantTitle;
    if (addToBasket) {
      addToBasket.disabled = !inStock;
      addToBasket.textContent = inStock ? 'ADD TO BASKET' : 'CURRENTLY OUT OF STOCK';
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  selectors.forEach((selector) => selector.addEventListener('change', updateVariant));
  addToBasket?.addEventListener('click', () => {
    if (!currentVariant?.available || !basketController) return;
    basketController.add({
      variantId: currentVariant.id,
      productTitle: productDetail.dataset.productTitle,
      variantTitle: currentVariant.title === 'Default Title' ? 'Vial' : currentVariant.title,
      price: currentVariant.price,
      priceFormatted: currentVariant.priceFormatted,
      productUrl: `${productDetail.dataset.productUrl}?variant=${currentVariant.id}`
    });
  });
  updateVariant();
}

const vault = document.querySelector('[data-coa-vault]');
if (vault) {
  const input = vault.querySelector('[data-coa-search]');
  const rows = Array.from(vault.querySelectorAll('[data-coa-row]'));
  const empty = vault.querySelector('[data-coa-empty]');
  input?.addEventListener('input', () => {
    const query = input.value.trim().toLowerCase();
    let visible = 0;
    rows.forEach((row) => {
      const match = (row.dataset.search || '').includes(query);
      row.hidden = !match;
      if (match) visible += 1;
    });
    if (empty) empty.hidden = visible !== 0;
  });
}
